import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ClarificationQuestion {
  id: string;
  question: string;
}
interface ClarificationStepProps {
  questions: ClarificationQuestion[];
  onSubmit: (answers: Record<string, string>) => void;
  onSkip?: () => void;
}
export function ClarificationStep({
  questions,
  onSubmit,
  onSkip
}: ClarificationStepProps) {
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const handleAnswerChange = (id: string, value: string) => {
    setAnswers(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = () => {
    onSubmit(answers);
  };
  const allAnswered = questions.every(q => answers[q.id]?.trim());
  return <div className="w-full max-w-2xl mx-auto" data-id="element-1">
      <div className="text-center mb-8" data-id="element-2">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-4" data-id="element-3">
          <div className="w-6 h-6 text-foreground" data-id="element-4" />
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2" data-id="element-5">
          A few clarifying questions
        </h2>
        <p className="text-muted-foreground" data-id="element-6">
          Help me understand your situation better for a more precise reframe.
        </p>
      </div>

      <div className="space-y-4 mb-6" data-id="element-7">
        {questions.map((q, index) => <div key={q.id} className="bg-card border border-border rounded-lg p-5" data-id="element-8">
            <label htmlFor={`question-${q.id}`} className="block text-foreground font-medium mb-3" data-id="element-9">
              <span className="text-muted-foreground mr-2" data-id="element-10">{index + 1}.</span>
              {q.question}
            </label>
            <textarea id={`question-${q.id}`} value={answers[q.id] || ''} onChange={e => handleAnswerChange(q.id, e.target.value)} placeholder="Your answer..." className="w-full min-h-[80px] p-3 rounded-md border border-border bg-background text-foreground placeholder:text-muted-foreground resize-y focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-colors" aria-label={`Answer to: ${q.question}`} data-id="element-11" />
          </div>)}
      </div>

      <div className="flex flex-col sm:flex-row gap-3" data-id="element-12">
        <button type="button" onClick={handleSubmit} disabled={!allAnswered} className={`
            flex-1 py-3 px-6 rounded-lg font-medium text-base
            inline-flex items-center justify-center gap-2
            transition-all duration-200
            ${!allAnswered ? 'bg-muted text-muted-foreground cursor-not-allowed' : 'bg-primary text-primary-foreground hover:opacity-90 active:scale-[0.98]'}
          `} aria-label="Continue with answers" data-id="element-13">
          Continue
          <ArrowRightIcon className="w-4 h-4" data-id="element-14" />
        </button>

        {onSkip && <button type="button" onClick={onSkip} className="py-3 px-6 rounded-lg font-medium text-base text-muted-foreground hover:text-foreground hover:bg-muted transition-colors" aria-label="Skip clarification questions" data-id="element-15">
            Skip for now
          </button>}
      </div>
    </div>;
}